module.exports = __webpack_public_path__ + "fonts/font.85b4f2e.woff";